module.exports = __webpack_public_path__ + "images/48aa6ef.jpg";